// src/Data/Experience.js

export const Experience = [
  {
    id: 1,
    title: "Graduate Student",
    company: "University of Illinois Springfield",
    duration: "2024 – 2026",
    description: [
 "Assisted with data collection, cleaning, and exploratory analysis for academic and policy-related projects.",
  "Applied machine learning techniques on text and image datasets to gain insights and improve model performance.",
  "Worked with tools such as Python, pandas, scikit-learn, and SQL for data processing and analysis.",
  "Collaborated with faculty and peers on research tasks, presentations, and project documentation.",
    ],
  },
  {
    id: 2,
    title: "Project Co-ordinator",
    company: "TKR Engineering College",
    duration: "2021 – 2023",
    description: [
"Coordinated a student research project focused on Natural Language Processing (NLP) and text classification.",
  "Built and tested models including Logistic Regression, Random Forest, Bi-LSTM, and DistilBERT to compare performance.",
  "Applied back-translation with MarianMT for data augmentation to improve training robustness.",
  "Explored combining traditional text features with modern embeddings to enhance model accuracy.",
  "Collaborated with teammates on documentation, presentations, and project delivery within academic timelines.",
    ],
  },
];
